import React, { FC, useRef } from 'react'
import Heading from '../../atoms/Heading/Heading';
import { motion, useInView } from 'framer-motion';
import { getImage } from '../../../app/utlis/imageConstants';
import DynamicSVG from '../../atoms/DynamicSvg/DynamicSvg';

interface ReliabilityIOSStepsProps {
    iosData: any
}

const ReliabilityIOSSteps: FC<ReliabilityIOSStepsProps> = ({ iosData }) => {
    // Ref for scroll animation
    const containerRef = useRef(null);

    // Use inView hook for scroll animation
    const isContainerInView = useInView(containerRef, { once: false, amount: 0.2 });

    // Animation variants
    const itemVariant = {
        hidden: { y: 50, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: { duration: 0.5, ease: "easeOut" }
        }
    };

    const containerVariant = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const iconVariant = {
        hidden: { scale: 0.8, opacity: 0 },
        visible: {
            scale: 1,
            opacity: 1,
            transition: {
                duration: 0.3,
                ease: "easeOut",
                delay: 0.1
            }
        }
    };

    return (
        <div className='p-4 sm:p-6 md:p-8 pt-8 md:pt-12'>
            <Heading subTitle='Reliability in every step' />
            <motion.div
                ref={containerRef}
                className='grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-8 lg:gap-14 md:p-4 sm:p-8 lg:p-20 pt-8 md:pt-16'
                variants={containerVariant}
                initial="hidden"
                animate={isContainerInView ? "visible" : "hidden"}
            >
                {iosData.ReliabilityIOSData.map((reliable: any, index: number) => {
                     let img = getImage(reliable.image ?? "") ?? "";
                    return (
                        <motion.div
                            key={index}
                            variants={itemVariant}
                            className='md:mb-6 md:mb-0 group pl-[10%] md:pl-[20%] lg:pl-[10%] xl:pl-[30%] 2xl:pl-[40%]'
                            whileHover={{
                                scale: 1.05,
                                transition: { duration: 0.2 },
                            }}
                        >
                            <motion.div
                                className={`w-[70px] h-[70px] sm:w-[80px] sm:h-[80px] lg:w-[35%] 2xl:w-[20%] xl:w-[30%] lg:h-[45%] xl:h-[50%] 2xl:h-[60%] p-4 bg-blackDarkTheme rounded-xl flex items-center justify-center mb-4 transition-all duration-300 ease-in-out transform group-hover:scale-105`}
                                variants={iconVariant}
                                initial={{
                                    border: 'none'
                                }}
                                whileHover={{
                                    border: `2px solid ${reliable.bgColor}`
                                }}
                            >
                                {/* <img src={reliable.image} className='w-[65%] h-[75%]' /> */}
                                 <DynamicSVG color='#fff' size='w-[65%] h-[75%]'>{img}</DynamicSVG>
                            </motion.div>
                            <div className='text-lg md:text-xl font-semibold '>{reliable.title}</div>
                            <div className='text-greyQuaternary text-sm md:text-base'>{reliable.subtitle}</div>
                        </motion.div>
                    )
                })}
            </motion.div>
        </div>
    )
}

export default ReliabilityIOSSteps
